import type { SVGProps } from 'react';
const SvgFossil = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <mask
      id="fossil_svg__a"
      width={33}
      height={26}
      x={3}
      y={6}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M3 6h32.883v25.826H3z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#fossil_svg__a)">
      <path
        fill="#1A1A1A"
        fillRule="evenodd"
        d="M35.883 24.972c-.13.188-.08.409-.11.614-.09.596-.558.948-1.178.85q-3.304-.524-6.609-1.054a444 444 0 0 1-3.255-.529c-.206-.034-.29.017-.358.217-1.02 2.987-3.07 5.048-6.12 6.168-1.672.615-3.408.725-5.176.435-2.591-.425-4.816-1.529-6.642-3.336-1.573-1.557-2.612-3.41-3.11-5.532-.667-2.84-.285-5.588.936-8.21 1.968-4.232 5.315-6.966 9.994-8.147 2.582-.652 5.187-.576 7.736.121 7.231 1.978 11.72 6.52 13.502 13.53.18.708.267 1.434.326 2.162.004.049-.007.105.064.12v.247c-.04.034-.031.08-.033.123.001.044-.006.09.033.124v.432a.45.45 0 0 0 0 .37v.616c-.044.04-.03.092-.033.141v.15c.004.05-.011.102.033.141z"
        clipRule="evenodd"
      />
    </g>
    <mask
      id="fossil_svg__b"
      width={1}
      height={1}
      x={35}
      y={23}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M35.569 23.223h.322v.57h-.322z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#fossil_svg__b)">
      <path
        fill="#1A1A1A"
        fillRule="evenodd"
        d="M35.891 23.704c-.097-.13-.102-.262 0-.392z"
        clipRule="evenodd"
      />
    </g>
    <mask
      id="fossil_svg__c"
      width={1}
      height={1}
      x={35}
      y={24}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M35.578 24.24h.313v.57h-.313z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#fossil_svg__c)">
      <path
        fill="#1A1A1A"
        fillRule="evenodd"
        d="m35.835 24.626.002-.195q.024-.05.054-.004v.196q-.026.043-.056.003"
        clipRule="evenodd"
      />
    </g>
    <mask
      id="fossil_svg__d"
      width={1}
      height={2}
      x={35}
      y={22}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M35.575 22.431h.316v.57h-.316z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#fossil_svg__d)">
      <path
        fill="#1A1A1A"
        fillRule="evenodd"
        d="M35.836 22.767c-.007-.054-.025-.111.055-.127v.13q-.03.046-.055-.003"
        clipRule="evenodd"
      />
    </g>
    <mask
      id="fossil_svg__e"
      width={1}
      height={2}
      x={35}
      y={22}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M35.576 22.543h.315v.57h-.315z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#fossil_svg__e)">
      <path
        fill="#1A1A1A"
        fillRule="evenodd"
        d="M35.836 22.76q.028 0 .055.004v.13c-.066-.024-.067-.077-.055-.134"
        clipRule="evenodd"
      />
    </g>
    <mask
      id="fossil_svg__f"
      width={1}
      height={1}
      x={35}
      y={24}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M35.577 24.088h.314v.57h-.314z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#fossil_svg__f)">
      <path
        fill="#1A1A1A"
        fillRule="evenodd"
        d="m35.891 24.436-.054.004c-.011-.057-.007-.107.054-.134z"
        clipRule="evenodd"
      />
    </g>
    <mask
      id="fossil_svg__g"
      width={1}
      height={1}
      x={35}
      y={24}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M35.575 24.395h.316v.57h-.316z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#fossil_svg__g)">
      <path
        fill="#1A1A1A"
        fillRule="evenodd"
        d="m35.835 24.616.056-.002v.131c-.077-.018-.064-.075-.056-.129"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M33.947 23.465c0 .237-.013.474.004.71.017.223-.065.278-.288.24-.948-.159-1.897-.307-2.846-.458-1.876-.3-3.752-.604-5.63-.893-.282-.043-.398-.101-.386-.427.067-1.816-.47-3.464-1.609-4.92-.163-.207-.153-.312.04-.495a635 635 0 0 0 5.152-4.952c.208-.202.3-.171.491.007 2.615 2.45 4.244 5.398 4.861 8.857a13.7 13.7 0 0 1 .212 2.331Zm-17.522-7.081c3.186-.016 5.844 2.143 6.354 4.884q.113.607.121 1.225c.003.177-.05.2-.222.171a96 96 0 0 0-2.213-.351c-.194-.028-.253-.097-.247-.295.058-2.212-1.69-3.942-3.985-3.943-.727 0-1.383.241-1.962.659a.89.89 0 0 0-.202 1.242c.294.409.871.56 1.3.244 1.047-.771 2.724.029 2.915 1.384.147 1.042-.567 2.215-1.606 2.636-1.597.649-3.56-.102-4.368-1.701-.756-1.495-.444-2.911.507-4.208.948-1.294 2.3-1.916 3.608-1.947m10.676-5.5c-.061.064-.123.132-.19.195-1.694 1.629-3.392 3.253-5.08 4.887-.156.15-.253.18-.442.046a7.8 7.8 0 0 0-2.985-1.285c-.177-.037-.253-.104-.252-.302.01-2.096.007-4.193.005-6.29 0-.153-.017-.263.223-.249 3.192.194 6.094 1.165 8.692 2.961.009.006.013.016.03.037ZM16.235 7.971v.354c0 1.962-.005 3.925.006 5.887 0 .241-.034.36-.323.382-.698.05-1.36.252-1.992.537-.151.069-.24.052-.357-.06a997 997 0 0 0-4.106-3.945c-.117-.112-.136-.17.003-.283 1.957-1.589 4.198-2.554 6.769-2.872M5.023 18.91c.283-2.664 1.63-5.198 2.96-6.588q1.994 1.919 3.994 3.83c.12.114.116.18 0 .288a6.2 6.2 0 0 0-1.559 2.3c-.05.126-.104.199-.269.198-1.678-.007-3.357-.005-5.036-.006-.03 0-.06-.015-.09-.022m2.442 1.87c.76 0 1.52.005 2.28-.004.175-.002.242.04.242.219.003 1.167.384 2.215 1.102 3.152.092.12.096.195-.023.307q-1.414 1.344-2.814 2.703c-.118.114-.183.114-.3-.002-1.738-1.718-2.742-3.762-2.976-6.152-.018-.184.027-.224.21-.222.76.009 1.52.004 2.28.004zm2.141 7.675c.994-.952 1.967-1.876 2.93-2.81.152-.148.25-.033.358.024a5.63 5.63 0 0 0 3.051.657c.594-.037.592-.036.733.512.213.826.418 1.654.649 2.475.063.223.006.288-.213.347-2.312.627-4.505.279-6.62-.728-.292-.14-.571-.306-.888-.477m9.555.308c-.277-1.068-.54-2.09-.812-3.11-.038-.14-.007-.224.112-.311a4.1 4.1 0 0 0 1.059-1.143c.066-.106.133-.156.281-.13.851.144 1.704.278 2.557.41.13.02.19.042.135.192-.616 1.716-1.711 3.07-3.332 4.092"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFossil;
